import React, { useState, useEffect, useRef } from "react";
import AuthService from "services/auth.service";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import SmsReminderService from "services/sms-reminder.service";
import SmsReminderLogsFilter from "./SmsReminderLogsFilter";

export function SmsReminderLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const isClosed = useRef(false);

  const defaultMeta = { total_count: 0, total_pages: 0, current_page: 1 };
  const [meta, setMeta] = useState(defaultMeta);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    getSmsReminderLogs(1);
    return () => {
      isClosed.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  const getSmsReminderLogs = (page) => {
    setPage(page);
    setLoading(true);
    const parameters = {
      page: page,
      start_date: startDate,
      end_date: endDate,
    };

    SmsReminderService.getSmsReminderLogs(parameters)
      .then(
        (data) => {
          setLogs(data.doctor_sms_reminders);
          setMeta(data.meta);
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace("/eb/login");
          }
        }
      )
      .then(() => {
        setLoading(false);
      });
  };
  const Logs = () => {
    if (loading)
      return (
        <tr className="loader">
          <td className="border-bottom-0">
            <Spinner animation="border" className="spinner" />
          </td>
        </tr>
      );

    return logs.map((n, i) => {
      return (
        <tr key={`sms-reminder-log-row-${i}`}>
          {/* Desktop View */}
          <td className="d-none d-lg-table-cell py-6 pr-4 pl-6">
            <div className="font-size-5 fweight-400">
              {i + 1 + (page - 1) * 12}
            </div>
          </td>
          <td className="d-none d-lg-table-cell py-6 pr-4 pl-6">
            <div className="font-size-6 fweight-400">{n.recipient_name}</div>
          </td>

          <td className="d-none d-lg-table-cell py-6 pr-4">
            <div className="font-size-6 fweight-400">
              {n.phone ? (
                n.phone
              ) : (
                <div
                  style={{
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  -
                </div>
              )}
            </div>
          </td>
          <td className="d-none d-lg-table-cell py-6 pr-4 w-50">
            <div className="font-size-6 fweight-400">{n.body}</div>
          </td>

          <td className="d-none d-lg-table-cell py-6 pr-4 w-20">
            <div className="font-size-6 fweight-400">{n.was_sent}</div>
          </td>

          <td className="details d-none d-lg-table-cell">
            <div className="datetime font-size-6 fweight-400">
              {n.sent_at ? (
                moment(n.sent_at).format("DD MMM YYYY, HH:mm A")
              ) : (
                <div
                  style={{
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  -
                </div>
              )}
            </div>
          </td>

          {/* Mobile View */}
          <td
            colSpan="6"
            valign="top"
            className={
              "d-table-cell d-lg-none font-size-7 py-6 pl-6 border-black"
            }
          >
            <div className="d-lg-none font-size-7 py-4 px-4">
              <div className="mobile-row">
                <span className="d-inline-block w-em-20 fweight-500">
                  Recipient Name:
                </span>
                <b>{n.recipient_name}</b>
              </div>
              <br />
              <div className="mobile-row">
                <span className="d-inline-block w-em-20 fweight-500">
                  Phone Number:
                </span>
                <b>{n.phone ? n.phone : "-"}</b>
              </div>
              <br />
              <div className="mobile-row">
                <span className="d-inline-block w-em-20 fweight-500">
                  Status:
                </span>
                <b>{n.was_sent}</b>
              </div>
              <br />
              <div className="mobile-row">
                <span className="d-inline-block w-em-20 fweight-500">
                  Time:
                </span>
                <b>
                  {n.sent_at
                    ? moment(n.sent_at).format("DD MMM YYYY, HH:mm A")
                    : "-"}
                </b>
              </div>
              <br />
              <div className="mobile-row">
                <span className="d-inline-block w-em-20 fweight-500">
                  Message Body:
                </span>
                <b>{n.body}</b>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  };

  const EmptyRow = () => {
    return (
      <tr className="position-relative">
        <td
          colSpan="6"
          className="text-center font-size-7 fweight-500 py-4"
          style={{ borderRadius: "0.5em" }}
        >
          No sms reminder log available
        </td>
      </tr>
    );
  };

  return (
    <div id="main-content-target" className="sms-reminder-page">
      <h1 className="text-danger">Sms Reminder Logs</h1>
      <div>
        <SmsReminderLogsFilter
          getSmsReminderLogs={getSmsReminderLogs}
          meta={meta}
          page={page}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
        {loading ? (
          <div className="d-flex justify-content-center my-12">
            <Spinner animation="border" className="spinner" />
          </div>
        ) : (
          <table id="sms-reminder-log-table" className="w-100">
            <thead className="d-none d-lg-table-header-group sms-reminder-log-header">
              <tr>
                {[
                  "No.",
                  "Recipient Name",
                  "Phone Number",
                  `Message Body`,
                  "Sent",
                  "Time",
                ].map((name, index) => {
                  const padding = index > 0 ? "pr-4" : "px-4";
                  return (
                    <th
                      key={"table-header-" + name}
                      className={
                        "font-size-7 fweight-500 position-relative " + padding
                      }
                    >
                      {name}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>{logs.length === 0 ? <EmptyRow /> : <Logs />}</tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default SmsReminderLogs;
